export const arm_sleeves = {
  msrp: 14.99,
  infoLink: 'https://www.teamtriton.com/arm-sleeves.html',
  items: [
    {
      number: 'AS099',
      hasModel: false,
    },
    {
      number: 'AS100',
      hasModel: false,
    },
    {
      number: 'AS101',
      hasModel: false,
    },
    {
      number: 'AS102',
      hasModel: false,
    },
    {
      number: 'AS103',
      hasModel: false,
    },
    {
      number: 'AS104',
      hasModel: false,
    },
    {
      number: 'AS105',
      hasModel: false,
    },
    {
      number: 'AS106',
      hasModel: false,
    },
    {
      number: 'AS107',
      hasModel: false,
    },
    {
      number: 'AS108',
      hasModel: false,
    },
    {
      number: 'AS109',
      hasModel: false,
    },
    {
      number: 'AS110',
      hasModel: false,
    },
    {
      number: 'AS111',
      hasModel: false,
    },
    {
      number: 'AS112',
      hasModel: false,
    },
    {
      number: 'AS113',
      hasModel: false,
    },
    {
      number: 'AS114',
      hasModel: false,
    },
    {
      number: 'AS115',
      hasModel: false,
    },
  ],
};
